<template>
<g>
<g v-show="valor === 0">
	<g id="Largo2">
	<path class="st8" d="M650.7,748.2h7.4v51.1h24.5v6.2h-31.9V748.2z"/>
	<path class="st8" d="M713.3,805.5l-0.6-5.2h-0.3c-2.3,3.2-6.7,6.1-12.6,6.1c-8.3,0-12.6-5.9-12.6-11.8c0-9.9,8.8-15.4,24.7-15.3
		v-0.9c0-3.4-0.9-9.5-9.4-9.5c-3.8,0-7.8,1.2-10.7,3.1l-1.7-4.9c3.4-2.2,8.3-3.7,13.5-3.7c12.6,0,15.6,8.6,15.6,16.8v15.4
		c0,3.6,0.2,7.1,0.7,9.9H713.3z M712.2,784.5c-8.2-0.2-17.4,1.3-17.4,9.3c0,4.8,3.2,7.1,7.1,7.1c5.4,0,8.8-3.4,9.9-6.9
		c0.3-0.8,0.4-1.6,0.4-2.4V784.5z"/>
	<path class="st8" d="M731.5,777.2c0-4.8-0.1-9-0.3-12.8h6.5l0.3,8.1h0.3c1.9-5.5,6.4-9,11.4-9c0.9,0,1.4,0.1,2.1,0.3v7.1
		c-0.8-0.2-1.5-0.3-2.6-0.3c-5.3,0-9,4-10,9.6c-0.2,1-0.3,2.2-0.3,3.5v21.9h-7.4V777.2z"/>
	<path class="st8" d="M794,764.4c-0.2,3-0.3,6.3-0.3,11.3v23.9c0,9.4-1.9,15.2-5.9,18.8c-4,3.7-9.8,4.9-15,4.9
		c-4.9,0-10.4-1.2-13.7-3.4l1.9-5.7c2.7,1.7,7,3.2,12.1,3.2c7.7,0,13.3-4,13.3-14.4v-4.6h-0.2c-2.3,3.8-6.7,6.9-13.1,6.9
		c-10.2,0-17.5-8.7-17.5-20.1c0-13.9,9.1-21.8,18.5-21.8c7.1,0,11.1,3.7,12.8,7.1h0.2l0.3-6.2H794z M786.3,780.6
		c0-1.3-0.1-2.4-0.4-3.4c-1.4-4.3-5-7.9-10.5-7.9c-7.1,0-12.2,6-12.2,15.6c0,8.1,4.1,14.8,12.2,14.8c4.6,0,8.8-2.9,10.4-7.7
		c0.4-1.3,0.6-2.7,0.6-4V780.6z"/>
	<path class="st8" d="M843.3,784.6c0,15.2-10.5,21.8-20.5,21.8c-11.1,0-19.7-8.2-19.7-21.2c0-13.8,9-21.8,20.4-21.8
		C835.4,763.4,843.3,772,843.3,784.6z M810.7,785c0,9,5.2,15.8,12.5,15.8c7.1,0,12.5-6.7,12.5-16c0-7-3.5-15.8-12.3-15.8
		S810.7,777.2,810.7,785z"/>
</g>
</g>
<g v-show="valor === 1">
<g xmlns="http://www.w3.org/2000/svg">
	<path class="st5" d="M685.9,744.5c6.9,0,12.1,2.8,15.8,8.3c3.6,5.5,5.4,13.6,5.4,24.1c0,10.5-1.8,18.6-5.4,24.1   c-3.6,5.6-8.9,8.3-15.8,8.3c-6.9,0-12.2-2.8-15.8-8.3c-3.6-5.5-5.4-13.6-5.4-24.1c0-10.5,1.8-18.5,5.4-24.1   C673.7,747.2,678.9,744.5,685.9,744.5z M685.9,751.1c-4.1,0-7.2,2.2-9.3,6.5c-2.1,4.4-3.2,10.8-3.2,19.2c0,8.3,1.1,14.7,3.2,19.1   c2.1,4.4,5.2,6.6,9.3,6.6c4,0,7-2.2,9.1-6.5c2.1-4.4,3.2-10.7,3.2-18.9c0-8.5-1-14.9-3.1-19.3C693,753.3,689.9,751.1,685.9,751.1z" style=""/>
	<path class="st5" d="M721.6,798.6h9.1l-7.4,20.7H716L721.6,798.6z"/>
	<path class="st5" d="M767.2,745.6h10.5v41.6h9.1v6.9h-9.1v14h-8.2v-14H740v-8L767.2,745.6z M769.7,753.3l-22.6,33.9h22.4   L769.7,753.3z"/>
	<path class="st5" d="M798.1,745.6h34.4v6.6h-26.3l-0.4,17.3c1.5-0.3,3-0.5,4.4-0.7c1.4-0.1,2.7-0.2,4.1-0.2   c6.4,0,11.5,1.7,15.2,5.1s5.6,8.1,5.6,13.9c0,6.5-2.2,11.6-6.7,15.4s-10.5,5.7-18.1,5.7c-2.2,0-4.4-0.2-6.6-0.6s-4.5-1-6.7-1.8   l-0.1-8.1c1.9,1.1,4,1.9,6.2,2.5s4.7,0.9,7.3,0.9c4.8,0,8.7-1.3,11.6-3.8s4.3-5.8,4.3-10c0-3.8-1.4-6.9-4.1-9.1s-6.4-3.4-11-3.4   c-1.8,0-3.8,0.2-6.1,0.5c-2.3,0.3-4.8,0.8-7.4,1.5L798.1,745.6z"/>
</g>
</g>
<g v-show="valor === 2">
<g xmlns="http://www.w3.org/2000/svg" id="_x32_nn_2_">
	<path class="st7" d="M657.6,800.4h28.6v7.1h-39v-7.3c11.3-11.2,18.8-19.5,22.7-24.9c3.9-5.4,5.8-10.1,5.8-13.9   c0-2.9-1.1-5.3-3.2-7.1s-4.9-2.8-8.4-2.8c-2.3,0-4.7,0.4-7.1,1.1c-2.4,0.8-4.7,1.9-6.9,3.4l-1-8c2.9-1.3,5.8-2.3,8.7-3   c2.9-0.7,5.8-1,8.7-1c5.2,0,9.5,1.6,12.8,4.7c3.3,3.1,4.9,7.2,4.9,12.2c0,4.8-1.9,10.1-5.8,15.9   C674.6,782.8,667.6,790.6,657.6,800.4z" style=""/>
	<path class="st7" d="M736.9,771.2c1.7-3.2,3.8-5.7,6.4-7.3c2.6-1.7,5.6-2.5,8.9-2.5c4.7,0,8.3,1.6,10.8,4.8   c2.5,3.2,3.7,7.9,3.7,14.1v27.3h-8.3v-25.4c0-4.5-0.7-7.9-2.2-10.1c-1.4-2.2-3.6-3.3-6.6-3.3c-3.6,0-6.5,1.4-8.5,4.2   c-2.1,2.8-3.1,6.7-3.1,11.6v23h-8.3v-25.4c0-4.7-0.7-8.1-2.1-10.2c-1.4-2.1-3.7-3.2-6.9-3.2c-3.4,0-6.1,1.4-8.1,4.3   c-2.1,2.8-3.1,6.7-3.1,11.5v23H701v-45.2h7.7v8.3c1.6-3,3.7-5.4,6.2-7c2.5-1.6,5.4-2.4,8.7-2.4c3.2,0,5.9,0.8,8.1,2.5   C734,765.5,735.7,768,736.9,771.2z"/>
	<path class="st7" d="M816.5,771.2c1.7-3.2,3.8-5.7,6.4-7.3c2.6-1.7,5.6-2.5,8.9-2.5c4.7,0,8.3,1.6,10.8,4.8   c2.5,3.2,3.7,7.9,3.7,14.1v27.3h-8.3v-25.4c0-4.5-0.7-7.9-2.2-10.1c-1.4-2.2-3.6-3.3-6.6-3.3c-3.6,0-6.5,1.4-8.5,4.2   c-2.1,2.8-3.1,6.7-3.1,11.6v23h-8.3v-25.4c0-4.7-0.7-8.1-2.1-10.2s-3.7-3.2-6.9-3.2c-3.4,0-6.1,1.4-8.1,4.3   c-2.1,2.8-3.1,6.7-3.1,11.5v23h-8.3v-45.2h7.7v8.3c1.6-3,3.7-5.4,6.2-7c2.5-1.6,5.4-2.4,8.7-2.4c3.2,0,5.9,0.8,8.1,2.5   C813.6,765.5,815.3,768,816.5,771.2z"/>
</g>
</g>
</g>
</template>

<script>

export default {
  name: 'canto2',
  props: { valor: Number },
  data: function () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Canto2.vue